import React from 'react';
import { createStyles, Grid, makeStyles, TextField, Typography } from '@material-ui/core';

import { UserContext } from '../UserContext';
import { UserModel } from '../../../Models/UserModel';
import { validNumber } from '../../../shared/operators';

export interface IConfirmCodeProps {
    onBack: () => void
}

const useStyles = makeStyles(() => createStyles({
    container: {
        width: '430px'
    },
    itens: {
        marginTop: '20px',
        width: '100%'
    },
    textLink: {
        margin: '4px',
        cursor: 'pointer'
    }
}));

export function ConfirmCode({ onBack }: IConfirmCodeProps) {
    const classes = useStyles();

    return (
        <Grid
            container
            direction="column"
            justify="center"
            alignItems="flex-start"
            className={classes.container}>
            <Typography
                variant='subtitle2'
                className={classes.textLink}
                onClick={onBack}>
                Voltar
            </Typography>
            <Typography
                variant='h3'
                color="textPrimary">
                Verifique o Link no seu e-mail
            </Typography>
            <Typography
                variant='body1'
                color="textSecondary">
                Enviamos um e-mail com um link para redefinir sua senha. Por favor, confira sua caixa de entrada ou a pasta de spam.
            </Typography>
        </Grid>
    );
}
